module.exports = "/virtual-football-league/img/btn-background-green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/btn-background-green.png
// module id = 327
// module chunks = 4